export default "__VITE_ASSET__DNORQqMq__"